export default __webpack_public_path__ + "static/media/log_out.757727c9.svg";